import React from 'react';
import { CircularProgress } from '@material-ui/core/';
import PropTypes from 'prop-types';

const Loader = (props) => {
  return <CircularProgress className={props.className} size={props.size} thickness={7.2} color="inherit" />;
};

Loader.defaultProps = {
  size: 12,
};

Loader.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default Loader;
